<div class="filter-group" data-group-visibility-id="showVendorRecipeFiltersPoe1">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showVendorRecipeFiltersPoe1" (click)="filter.groupVisibility.showVendorRecipeFiltersPoe1 = !filter.groupVisibility.showVendorRecipeFiltersPoe1; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Vendor Recipes" [activeRules]="activeRules.vendorRecipeFiltersPoe1">
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showVendorRecipeFiltersPoe1) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showVendorRecipeFiltersPoe1">
      <app-vendoring-gear [filter]="filter" [includeMagics]="true"></app-vendoring-gear>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showJewellersRecipe">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showJewellersRecipe"
            (click)="toggleShowJewellersRecipe()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Jeweller's Recipe" ruleId="gear-recipe-jewellers-six-socketed" [additionalContent]="jewellersRecipeStylePreview">
            Selling an item with 6 sockets will yield 7 <span class="currency-color">Jeweller's Orbs</span>.
            <ng-template #jewellersRecipeStylePreview>
              <app-equipment-tier-picker
                sockets="WWWWWW"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeJewellers"
                [active]="filter.showJewellersRecipe"
                [disabled]="!filter.showJewellersRecipe"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showChromaticRecipe">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showChromaticRecipe"
            (click)="toggleShowChromaticRecipe()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Chromatic Recipe" ruleId="gear-recipe-chromatic" [additionalContent]="chromaticRecipeStylePreview">
            Selling an item with a <strong>linked Red, Green and Blue socket</strong> will yield a <span class="currency-color">Chromatic Orb</span>.
            <ng-template #chromaticRecipeStylePreview>
              <app-equipment-tier-picker
                sockets="LRGB"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeChromatic"
                [active]="filter.showChromaticRecipe"
                [disabled]="!filter.showChromaticRecipe"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.SmallOnly, GearSizeType.TwoByTwoOnly]"
            [disabled]="!filter.showChromaticRecipe"
            [(ngModel)]="filter.showChromaticRecipeType"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showChaosRecipe">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showChaosRecipe"
            (click)="toggleShowChaosRecipe()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Chaos Recipe" ruleId="gear-recipe-chaos" [additionalContent]="chaosRecipeStylePreview">
            Selling a <strong>Full Unidentified Rare Set</strong> (Helmet, Glove, Boot, Body Armour, 2-Handed Weapon, Ring, Amulet and Belt) between levels 60 and 74 will yield 2 <span class="currency-color">Chaos Orbs</span>.
            <br />
            <br />If you're only looking for gear for one slot, you can select that slot as your current target.
            <ng-template #chaosRecipeStylePreview>
              <app-equipment-tier-picker
                [rarity]="Rarity.Rare"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeChaos"
                [active]="filter.showChaosRecipe"
                [disabled]="!filter.showChaosRecipe"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 140px"
            [options]="recipeTarget"
            [disabled]="!filter.showChaosRecipe"
            [showOptions]="true"
            [selectedValues]="filter.showChaosRecipeTarget"
            (selectedValuesChange)="chaosRecipeTargetChanged($event)"
          ></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExaltRecipe">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExaltRecipe"
            (click)="toggleShowExaltRecipe()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Exalt Recipe" ruleId="gear-recipe-exalt" [additionalContent]="exaltRecipeStylePreview">
            Selling a <strong>Full Unidentified Rare Set</strong> (Helmet, Glove, Boot, Body Armour, 2-Handed Weapon, Ring, Amulet and Belt) of the same <strong>influence</strong> (Shaper, Elder, Crusader, Hunter, Redeemer, Warlord) will yield 2 <span class="currency-color">Exalted Orb</span>s.
            <br />
            <br />If you're only looking for gear for one slot, you can select that slot as your current target.
            <ng-template #exaltRecipeStylePreview>
              <app-equipment-tier-picker
                [rarity]="Rarity.Rare"
                [influence]="filter.showExaltRecipeInfluence.length > 0 && filter.showExaltRecipeInfluence[0] !== 'All' ? filter.showExaltRecipeInfluence[0] : 'Shaper'"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeExalt"
                [active]="filter.showExaltRecipe"
                [disabled]="!filter.showExaltRecipe"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 140px"
            [options]="influences"
            [disabled]="!filter.showExaltRecipe"
            [showOptions]="true"
            [selectedValues]="filter.showExaltRecipeInfluence"
            (selectedValuesChange)="exaltRecipeInfluenceChanged($event)"
          ></app-autocomplete>
          <span class="sep"></span>
          <app-autocomplete style="width: 140px"
            [options]="recipeTarget"
            [disabled]="!filter.showExaltRecipe"
            [showOptions]="true"
            [selectedValues]="filter.showExaltRecipeTarget"
            (selectedValuesChange)="exaltRecipeTargetChanged($event)"
          ></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityWeapons">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityWeapons"
            (click)="toggleShowQualityWeapons()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Qual. Weapons' : 'Quality Weapons' }}" ruleId="gear-recipe-quality-weapons" [additionalContent]="qualityWeaponsRecipeStylePreview">
            <ng-template #qualityWeaponsRecipeStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Weapon"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeQualityWeapons"
                [active]="filter.showQualityWeapons"
                [disabled]="!filter.showQualityWeapons"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityWeapons"
            [(ngModel)]="filter.showQualityWeaponsMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.SmallOnly, GearSizeType.TwoByTwoOnly]"
            [disabled]="!filter.showQualityWeapons"
            [(ngModel)]="filter.showQualityWeaponsSize"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityArmour">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityArmour"
            (click)="toggleShowQualityArmour()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Qual. Armour' : 'Quality Shields and Armour'" ruleId="gear-salvaging-quality-armour" [additionalContent]="qualityArmourRecipeStylePreview">
            <ng-template #qualityArmourRecipeStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Armour"
                [equipmentType]="EquipmentType.OtherGearSalvagingRecipeQualityArmour"
                [active]="filter.showQualityArmour"
                [disabled]="!filter.showQualityArmour"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityArmour"
            [(ngModel)]="filter.showQualityArmourMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.TwoByTwoOnly]"
            [disabled]="!filter.showQualityArmour"
            [(ngModel)]="filter.showQualityArmourSize"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityFlasks"
            (click)="toggleShowQualityFlasks()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Qual. Flasks' : 'Quality Flasks' }}" ruleId="flasks-recipe-quality" [additionalContent]="qualityFlasksRecipeStylePreview">
            <ng-template #qualityFlasksRecipeStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Quicksilver Flask"
                [equipmentType]="EquipmentType.OtherFlasksQuality"
                [active]="filter.showQualityFlasks"
                [disabled]="!filter.showQualityFlasks"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityFlasks"
            [(ngModel)]="filter.showQualityFlasksMinQuality" (change)="updateFilter()">
        </span>
      </div>

    </div>
    <div class="clear"></div>
  }
</div>

